import React from 'react';
import { Modal, Button, message } from 'antd';
import './Login.css';
import AuthForm from './AuthForm';

interface MenuRegistrationProps {
  visible: boolean;
  loading: boolean;
  onCancel: () => void;
  onLogin: () => void;
}

const MenuRegistration: React.FC<MenuRegistrationProps> = ({ visible, loading, onCancel, onLogin }) => {

  return (
    <Modal
      title={null}
      open={visible}
      onCancel={onCancel}
      footer={null}
      destroyOnClose
      centered
      className="login-widget-modal"
      width={900}
    >
      <div className="login-widget-container">
        <AuthForm 
          mode="register" 
          defaultTab="student"
          onSuccess={() => {
            message.success('Registration successful! Please login to continue.');
            onLogin(); // Switch to login view after successful registration
          }}
          className="login-widget-form"
        />
        
        <div className="login-widget-footer">
          <span>Already have an account? </span>
          <Button type="link" onClick={onLogin} className="register-link-btn">
            Login
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MenuRegistration; 